export default __webpack_public_path__ + "static/media/02.4747dd8a.jpg";